/**
 * @generated SignedSource<<cc0b21eea0ff374b573b74c02d73783d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoListItemDescription_todo$data = {
  readonly descriptionFiles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContentFiles_files">;
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContent_images">;
  }>;
  readonly linkedProducts: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ListItemDescriptionContentProducts_products">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WorkspaceTodoListItemDescription_todo";
};
export type WorkspaceTodoListItemDescription_todo$key = {
  readonly " $data"?: WorkspaceTodoListItemDescription_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoListItemDescription_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoListItemDescription_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemDescriptionContent_images"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemDescriptionContentFiles_files"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WorkspaceProduct",
      "kind": "LinkedField",
      "name": "linkedProducts",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ListItemDescriptionContentProducts_products"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};

(node as any).hash = "de35428db45e406cd754bfd59ae1228b";

export default node;
